import { Badge, type SemanticTone } from '@kerfjs/ui/badge';
import type { SafeHtml } from 'kerfjs';

export const DECISION_LABELS: Record<string, string> = {
  approve: 'Approve',
  negotiate: 'Negotiate',
  reject: 'Reject',
  defer: 'Defer',
  import: 'Import',
  're-quote': 'Re-Quote',
};

export const DECISION_TONES: Record<string, SemanticTone> = {
  approve: 'success',
  negotiate: 'warning',
  reject: 'danger',
  defer: 'neutral',
  import: 'pop',
  're-quote': 'info',
};

export function DecisionBadge({ action }: { action: string | null }): SafeHtml {
  return (
    <Badge
      tone={action === null ? 'neutral' : (DECISION_TONES[action] ?? 'neutral')}
      shape="pill"
      className="decision-badge"
    >
      {action === null ? 'Pending' : (DECISION_LABELS[action] ?? action)}
    </Badge>
  );
}
